
export default [
  {
    path: '/web/Login',
    name: 'WebLogin',
    component: () => import('@/view/Login')
  },
  {
    path: '/web/index',
    name: 'WebIndex',
    component: () => import('@/view/web/Index')
  },
  {
    path: '/web/Coupon',
    name: 'WebCoupon',
    component: () => import('@/view/web/Coupon')
  },
  {
    path: '/web/DiscountCode',
    name: 'WebDiscountCode',
    component: () => import('@/view/web/child/DiscountCode')
  },
  {
    path: '/web/DayReport',
    name: 'WebDayReport',
    component: () => import('@/view/web/DayReport')
  },
  {
    path: '/web/MonthReport',
    name: 'WebMonthReport',
    component: () => import('@/view/web/MonthReport')
  },
]



// WEBPACK FOOTER //
// ./src/router/web.js